import { LocalNotifications } from 'src/boot/localNotification'
import { findNextValidNotificationDate } from 'src/utils/findNextValidNotificationDate'

export const NotificationService = {
  async scheduleNotification(notification, forceClear = false) {
    if (forceClear) {
      await this.clearNotifications()
    }
    notification.id = Math.floor(Math.random() * 1000)
    const date = findNextValidNotificationDate().toDate()
    notification.schedule = {
      at: date,
      allowWhileIdle: true
    }
    await LocalNotifications.schedule({
      notifications: [notification]
    })
    const nextDate = findNextValidNotificationDate(notification.schedule.date).toDate()
    notification.schedule.at = nextDate
    await LocalNotifications.addListener('localNotificationReceived', () => {
      this.scheduleNotification(notification, true)
    })
  },
  async clearNotifications() {
    const pendingNotifications = await LocalNotifications.getPending()
    if (pendingNotifications.notifications.length) {
      const notifications = pendingNotifications.notifications.map((n) => {
        return {
          id: `${n.id}`
        }
      })
      await LocalNotifications.cancel({
        notifications
      })
    }
    await LocalNotifications.removeAllListeners()
  }
}
